<template>
  <b-overlay :show="loading" rounded="sm">
    <b-container class="form-welcome">
      <b-row class="welcome">
        <b-col cols="12">
          <img src="../Img/dolar.svg" class="img-welcome" alt="Welcome image">
        </b-col>
      </b-row>
      <b-col cols="10" class="col-welcome">
        <span class="title-welcome" :class="{'title-welcome-score': hasSavedScore}"
              tabindex="0" v-html="hasSavedScore ? $t('welcome_back') : $t('welcome_finfit')">
        </span>
      </b-col>

      <div class="col-10 separator-title-welcome" v-if="hasSavedScore"></div>

      <b-col cols="11" class="mx-auto" aria-labelledby="customer-label">
        <div v-if="hasSavedScore" class="d-flex">
          <div class="mr-3" tabindex="0" :aria-label="getTotalScoreAriaLabel()">
            <div tabindex="-1" class="content-welc small-title-score">{{ $t('score') }}</div>
            <div tabindex="-1" class="total-score">{{ score }}</div>
          </div>
          <div tabindex="0" class="content-welc des-score">
            {{ $t("update_my_score_desc") }}
          </div>
        </div>
        <span class="content-welc " tabindex="0" id="customer-label" v-else>
          {{ $t("finfit_description") }}
        </span>
      </b-col>
      <b-col cols="12" class="button-take-test">
        <b-button class="my-5 take-test" variant="primary" type="button" @click="takeTest" @keyup.enter.space="takeTest">
          {{ hasSavedScore ? $t("update_score_btn") : $t("take_test") }}
        </b-button>
      </b-col>
    </b-container>
  </b-overlay>
</template>

<script>
  import { QuestionService } from '../Services'
  import {Constant, Storage, UtilsI18n} from "../../../core/Utils";
  import {AuthService} from "../../Security/Services";

  export default {
    name: "Start",
    data() {
      return {
        loading: false,
        hasSavedScore: false,
        score: 0
      }
    },
    methods: {
      takeTest() {
        this.loading = true
        Storage.setInitialTimestamp(Date.now())
        Storage.removeItemAnswers()
        if (navigator.onLine) {
          QuestionService.loadQuestionsAndCompetencies().then(() => {
            this.$router.push({name: 'Quiz', params: {questionNumber: Constant.INITIAL_QUESTION}})
          }).catch(() => this.loading = false)
        } else {
          this.$router.push({name: 'Quiz', params: {questionNumber: Constant.INITIAL_QUESTION}})
        }
      },
      getTotalScoreAriaLabel: function() {
        return UtilsI18n.interpolateString(this.$t("total_score"), {total_score: this.score})
      },
    },
    created() {
      this.hasSavedScore = false
      if (navigator.onLine && AuthService.isValidAuthenticate()) {
        QuestionService.getLastScore().then(response => {
          this.hasSavedScore = true
          this.score = response
        }).catch(() => {
          this.score = 0
        })
      } else {
        this.score = Storage.getUserScore()
        this.hasSavedScore = this.score !== false
      }
    }
  }

</script>

<style lang="stylus" scoped>

  @import "~@/core/Styles/variables.styl"

  .form-welcome
    background linear-gradient(to bottom, color-fucsia, color-purple 70%, color-purple)
    min-height 100vh
    margin-top 0

  .img-welcome
    margin-top 20px
    width 320px
    height 380px

  .welcome
    text-align right

  .col-welcome
    margin-left 20px
    margin-bottom 20px

  .title-welcome
    color color-white
    font-family 'Roboto Slab', serif;
    &.title-welcome-score
      &::v-deep
        span
          font-size 30px
        sup
          font-size 16px
          top -0.7em
    &::v-deep
      span
        font-weight 700
        font-size 36px
        line-height 1.3
      sup
        font-size 18px
        font-weight 400
        top -0.8em

  .separator-title-welcome
    width 100%
    height 1px
    background-color rgba(255, 255, 255, .5)
    margin-bottom 20px
    margin-left 35px

  .small-title-score
    color #ffffff
    font font-opensans-sem
    font-weight 700 !important
    text-transform uppercase

  .total-score
    font-family 'Roboto Slab', serif
    font-weight 700
    font-size 90px
    color #ffffff
    line-height 0.9

  .content-welc
    color color-white
    font font-opensans
    line-height 21px

  .take-test
    background color-lime-green
    width 70%
    color color-black
    font font-opensans-cond
    border solid 2px color-lime-green

    &:hover
      background color-orange
      border solid 2px color-orange

  .button-take-test
    text-align center


</style>
